import type { NskResponse } from '~/models/Api';
import { postRequest } from '~/utils/api/api_handler';
import type {
  Type,
  Encoding,
  CsvRequestParams
} from '~/models/CsvGenerationResult';
import type { DealSearchCondition } from '~/models/Deal';

const createPath = '/csv_generation_results';

export const requestCsvGenerate = (
  parameters: DealSearchCondition,
  csvType: Type,
  encoding: Encoding,
  endpoint = createPath
): Promise<NskResponse<CsvRequestParams>> =>
  postRequest<CsvRequestParams, null>(endpoint, {
    csv_generation_result: {
      parameters,
      csv_type: csvType,
      encoding
    }
  });

export const getPresignedUrl = async (id: number): Promise<string | null> => {
  const url = `${process.env.NEXT_PUBLIC_API_HOST}/api/csv_generation_results/${id}/download`;
  try {
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) {
      return null;
    }
    const data: { presigned_url: string } = await res.json();
    return data.presigned_url;
  } catch {
    return null;
  }
};
